
// import * as REDUX_ACTION from "../../services/redux/actions";

// import { TIME } from "../../services/util";

export const SelectCompanies = (company) => {
    let tree = [];
  
    if (company) {
      const allChildren = Object.keys(company).map((coid) => {
        const companyData = company[coid];

        return {
            title: `${companyData.name} (${coid})`,
            key: coid, 
            value: coid, 
        };
      });
  
      const allOption = {
        title: "All Companies",
        key: "ALL",
        value: "ALL",
      };
      const sortedChildren = allChildren.sort((a, b) => a.title.localeCompare(b.title));
  
      tree.push({ ...allOption, children: sortedChildren});
    }
    const filterSelectedChildren = (node) => {
      if (node.value === "ALL") {
        return tree.flatMap((n) => n.children.map((child) => child.value));
      }
  
      return [node.value];
    };
  
    tree.filterSelectedChildren = filterSelectedChildren;
  
    return tree;
  };


export const formatDate = (dateStr) => {
  const dateStrAsString = dateStr.toString();
  const day = dateStrAsString.slice(4, 6);
  const month = dateStrAsString.slice(2, 4);
  return `${month}/${day}`;
  // return new Date(month, day);
};

export const formatMonth = (dateStr) => {
  const dateStrAsString = dateStr.toString();
  const month = dateStrAsString.slice(2, 4);
  const monthsDisplay = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthIndex = parseInt(month, 10) - 1;
  const monthName = monthsDisplay[monthIndex];
  const year = dateStrAsString.slice(0, 2);
  return `${monthName} ${year}`;
}

export const formatTitleTooltip = (dateStr) => {
  const dateStrAsString = dateStr.toString();
  const day = dateStrAsString.slice(2, 4);
  const month = dateStrAsString.slice(0, 2);
  return `${day}/${month}`;
};
        
const calculateDateString = (date) => {
  const year = String(date.getFullYear()).slice(2); 
  const month = String(date.getMonth() + 1).padStart(2, '0'); 
  const day = String(date.getDate()).padStart(2, '0');
  return year + month + day;
};

export const filterByCompany = (data, filterByCompanies) => {
    return data.filter(d => {
      if (filterByCompanies.length > 0 && !filterByCompanies.includes('ALL')) {
        return filterByCompanies.includes(d.coid);
      }
      return true; // No company filter applied
    });
  };
  
export const filterByDays = (data, filterByDays) => {
  const now = new Date();
  // const nFirst = lastDay(90);
  // const nLast = currentTime();
  
  return data.filter(item => {
    if (typeof filterByDays === 'number') {
      const targetDate = new Date(now.getTime() - (filterByDays * 24 * 60 * 60 * 1000));
      const targetDateString = calculateDateString(targetDate);
      return item.createdDate >= targetDateString;
    } 
    // else if (Array.isArray(filterByDays)) {
    //   const [startDate, endDate] = filterByDays;
    //   const isRange = formattedDate(startDate) >= nFirst && formattedDate(endDate) <= nLast;

    //   if (!isRange) {
    //     dispatch(REDUX_ACTION.v1_dashboard.get_dashboard_timeframe_daily_all_request(startDate, endDate));
    //     return false; // Avoid including data if not in the range
    //   } else {
    //     return item.createdDate >= startDate && item.createdDate <= endDate;
    //   }
    // }
    return true; // No days filter applied
  });
};

export const applyFiltersMonth = (srcData, comp, year, setData, setIsFilter) => {

  const filteredData = srcData
      .filter(d => {
        // Apply the 'Company' filter
        if (comp.length > 0 && !comp.includes('ALL')) {
          return comp.includes(d.coid);
        }
        return true; // No company filter applied
      })
      .filter(item => {
        // Apply the 'years' filter
        if (typeof year === 'number') {
          const createdDateStr = String(item.createdDate); // Ensure it's a string
          if (createdDateStr.length >= 2) {
            const itemYear = parseInt(createdDateStr.substring(0, 2), 10);
            return (2000 + itemYear) === year;
          }
        }
       return true; // No filter applied
     });
     setData(filteredData);
     setIsFilter(false)
};

export const applyFilters = (srcData, filterByCompanies, filterByDays, setData, setIsFilter) => {
 
    const filteredData = srcData
      .filter(d => {
        // Apply the 'Company' filter
        if (filterByCompanies.length > 0 && !filterByCompanies.includes('ALL')) {
          return filterByCompanies.includes(d.coid);
        }
        return true; // No company filter applied
      })
      .filter(item => {
         // Apply the 'Days' filter
          const now = new Date();
          // const nFirst = lastDay(90);
          // const nLast = currentTime();
          let targetDateString;
      
          if (typeof filterByDays === 'number') {
            const targetDate = new Date(now.getTime() - (filterByDays * 24 * 60 * 60 * 1000));
            targetDateString = calculateDateString(targetDate);
            return item.createdDate >= targetDateString;
          } 
          // else if (Array.isArray(filterByDays)) {
          //   const [startDate, endDate] = filterByDays;

          //   const isRange = formattedDate(startDate) >= nFirst && formattedDate(endDate) <= nLast

          //   if (!isRange) {
          //       dispatch(REDUX_ACTION.v1_dashboard.get_dashboard_timeframe_daily_all_request(startDate, endDate))
          //   } else {
          //     return item.createdDate >= startDate && item.createdDate <= endDate;
          //   }
          // }
      
        return true; // No filter applied
      });
  
    setData(filteredData);
    setIsFilter(false)
};